import { getMemberCareNumberByProduct } from './getMemberCareNumberByProduct'
import { getAuthedUser } from '@sidecar-utilities/authedUser'

/**
 * This handy little abstraction helps make it easy to get the phone number for
 * member care, but without having to supply the product type. It's a bit like
 * the SidecarPhoneNumber component, but returns a string instead of JSX.
 *
 * @returns {string}
 */
export const getSidecarPhoneNumber = () => {
  const authUser = getAuthedUser()
  const insuranceProduct = authUser.policy?.insuranceProduct
  const dedicatedPhoneNumber = authUser.asoGroupDto?.dedicatedPhoneNumber

  return getMemberCareNumberByProduct(insuranceProduct, dedicatedPhoneNumber)
}
